export default __webpack_public_path__ + "static/media/bg.527ceab2.jpg";